export const StatusCircleCompleted = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 12C2.68629 12 0 9.31373 0 6C0 2.68629 2.68629 0 6 0C9.31373 0 12 2.68629 12 6C12 9.31373 9.31373 12 6 12ZM8.66132 4.68289C8.85868 4.44608 8.8267 4.09414 8.58988 3.8968C8.35306 3.69947 8.0011 3.73146 7.8038 3.96827L5.40435 6.84759L4.16211 5.60534C3.94414 5.38739 3.59075 5.38739 3.37278 5.60534C3.15481 5.82329 3.15481 6.17671 3.37278 6.39466L5.0472 8.06908C5.1581 8.17998 5.31047 8.23909 5.46714 8.232C5.62381 8.22486 5.77027 8.15219 5.87062 8.03174L8.66132 4.68289Z"
        fill="#017C3F"
      />
    </svg>
  );
};
